import config from './core/config';
import service from './core/service';
import helper from './core/helper';
import model from './core/model';
import handler from './core/handler';

import credencialController from './controllers/credencial';
import facebookController from './controllers/facebook';
import gmailController from './controllers/gmail';
import nativoController from './controllers/nativo';
import registroController from './controllers/registro';

(function (App, Controller, Service, Handler, Helper, Config, Model, LocalStorage, $) {
    'use strict';

    // ==================================================
    // Ejecicion inicial
    // ==================================================  	
    App.init = function () {
        if (!Helper.areCookiesEnabled()) {
            Service.displayCookiesDeshabilitadasView();
            return;
        }

        /*if(Config.SentryIngresar)
          Sentry && Sentry.init({ dsn: Config.SentryIngresar });*/
        Service.startGmailApi();
        Service.startFacebookApi();
        Service.startComscore();
        Service.startEstadisticas();
        Service.createCustomDimension();
        Service.startGoogleTagManager();
        Service.initializeGoogleAnalytics();
        Service.startHotjar();
        Handler.router();

        if (LocalStorage.checkIfExists(Config.LoginFlagKey) && LocalStorage.checkExpiration(Config.LoginFlagKey)) {
            LocalStorage.renew(Config.LoginFlagKey);
        }
        else {
            LocalStorage.setExpiredItem(Config.LoginFlagKey, false);
        }
    }

    App.reload = function () {
        Helper.resetAll(function () {
            App.init();
        });
    }

    // ==================================================
    // Step Handler Event
    // ==================================================  
    $(document.body).on('click', '.next-button', function (event) {        
        var t = $(this);
        var step = t.data('step');
        Handler.stepHandler(step,t);
        event.preventDefault();
        return false;
    });

    $('form').on('submit', function (e) {
        e.preventDefault();        
        var step = $('.next-step').data('step');
        var isDisabled = $('.next-step').is(":disabled");        
        if(Helper.canSubmit() && isDisabled == false){
            Helper.setCanSubmit(false);
            Handler.stepHandler(step);
        }   
    });

    $(document.body).on('keyup keypress', 'input', function (event) {  
        Handler.keypressHandler($(this),event);
    });

    //$(document.body).on('keyup keypress', function (event) {
    //    Handler.keypressHandler($(this), event);
    //});

    $(window).on('load', Helper.initialpreloader);

})(LN.App, LN.Controller, LN.Service, LN.Handler, LN.Helper, LN.Config, LN.Model, LN.LocalStorage, jQuery);

// ONLOAD
(function (LN) {
    try {
        LN.App.init();
    } catch (err) {      
        LN.Service.mostrarError(err, err);
    }
})(LN);


// WEBPACK FOOTER //
// ./Statics/scripts/login/app.js